/**
 * API(/apis/cmea/menus)에서 내려오는 메뉴 제목을 화면 표시용 명칭으로 변환합니다.
 */

const MENU_LABEL_BY_PATH = {
  '/performance-check/list': '휠복원점검',
  '/customer/company/list': '법인',
  '/customer/dealer/list': '고객',
  '/sales/payment/list': '휠복원점검료 수납',
  '/sales/receivable/list': '휠복원점검료 미수',
};

const MENU_TITLE_REPLACEMENTS = [
  ['매매상사목록', '법인목록'],
  ['매매상사', '법인'],
  ['성능점검료', '휠복원점검료'],
  ['성능점검', '휠복원점검'],
  ['성능지', '점검'],
  ['재성능', '재점검'],
  ['신규성능', '신규점검'],
  ['성능진단', '휠복원점검'],
];

export const localizeMenuTitle = (title, path) => {
  if (path && MENU_LABEL_BY_PATH[path]) {
    return MENU_LABEL_BY_PATH[path];
  }
  if (!title) {
    return title;
  }
  return MENU_TITLE_REPLACEMENTS.reduce(
    (label, [from, to]) => label.replaceAll(from, to),
    title
  );
};

const isHiddenSidebarMenu = (item) => {
  const path = String(item?.to || '').trim().toLowerCase();
  const label = String(item?.label || '').trim();
  if (path === '/dashboard') return true;
  if (/^home$/i.test(label)) return true;
  if (label === '대시보드') return true;
  return false;
};

/** 좌측 메뉴에서 HOME 그룹·대시보드 항목 제외 */
export const filterMenuModel = (menus = []) =>
  menus
    .map((item) => ({
      ...item,
      items: item.items?.length ? filterMenuModel(item.items) : item.items,
    }))
    .filter((item) => {
      if (isHiddenSidebarMenu(item)) return false;
      if (item.items?.length === 0) return false;
      return true;
    });

const localizeMenuItem = (item) => ({
  ...item,
  label: localizeMenuTitle(item.label, item.to),
  items: item.items?.length
    ? item.items.map(localizeMenuItem)
    : item.items,
});

export const mapMenuModel = (menus = []) =>
  filterMenuModel((menus || []).map(localizeMenuItem));
